
"use client";

import React, {useEffect, useState} from "react";
import {Card, CardBody, Spinner, Typography, CardFooter} from "@material-tailwind/react";
import {apiGetAsset, apiGetAssetImages} from "@/api/asset";
import {EMPTY_GUID} from "@/state/constants";
import {PmStore} from "@/state";
import {useRouter} from "next/navigation";
import placeholder from "../images/asset_placeholder.webp";


export default function AssetCard({assetId}) {
    const state = PmStore();
    const [Asset,SetAsset] = useState({});
    const [AssetImage,SetAssetImage] = useState(null);

    const [Loading, SetLoading] = useState(false);
    let navigate = useRouter();

    function GetAssetDetails(){
        if(!state?.selectedOrganization?.id) return;
        if(!assetId || assetId === EMPTY_GUID) return;
        apiGetAsset(state?.selectedOrganization?.id, assetId)
            .then((data) => {
                SetAsset(data)

                let imageUrl = "";
                if (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1")
                    imageUrl = "https://rentalflow.dwai.xyz"

                imageUrl = `${imageUrl}${data?.image?.url}`;
                SetAssetImage(imageUrl);

            })
            .then(() => SetLoading(false))
    }

    useEffect(() => {
        GetAssetDetails();


    }, [state]);


    if(Loading) return(<div className={"flex justify-center h-[400px]"}><Spinner /></div>)



    return (
        <div className="group cursor-pointer h-full" onClick={() => navigate.push("/asset/"+ assetId)}>
            <div className="h-full flex flex-col bg-white rounded-xl overflow-hidden border border-gray-200 hover:border-gray-300 transition-all">
                {/* Image Container */}
                <div className="relative aspect-[4/3] overflow-hidden bg-gray-100">
                    {Asset?.image_id != EMPTY_GUID ? (
                        <ImageWithLoader src={AssetImage ?? placeholder.src} />
                    ) : (
                        <img className="w-full h-full object-cover" src={placeholder.src} alt="Property placeholder" />
                    )}
                    {/* Price or Status Badge */}
                    {Asset?.type?.name && (
                        <div className="absolute top-3 left-3">
                            <span className="bg-white/95 backdrop-blur px-3 py-1 rounded-full text-sm font-medium text-gray-700">
                                {Asset.type.name}
                            </span>
                        </div>
                    )}
                </div>

                {/* Content */}
                <div className="flex-1 p-4">
                    <div className="mb-2">
                        <Typography variant="h6" className="font-semibold text-gray-900 mb-1 line-clamp-1">
                            {Asset?.name ?? "Property Name"}
                        </Typography>
                        <Typography variant="small" className="text-gray-600 flex items-center gap-1">
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
                            </svg>
                            {Asset?.location_name ?? "Location"}
                        </Typography>
                    </div>

                    {Asset?.address && (
                        <Typography variant="small" className="text-gray-500 mb-3 line-clamp-1">
                            {Asset.address}
                        </Typography>
                    )}

                    {Asset?.description && (
                        <Typography className="text-sm text-gray-600 line-clamp-2 mb-4">
                            {Asset.description}
                        </Typography>
                    )}
                </div>

                {/* Footer */}
                <div className="px-4 py-3 border-t border-gray-100">
                    <div className="flex items-center justify-between">
                        <Typography variant="small" className="text-gray-500">
                            View Details
                        </Typography>
                        <svg className="w-4 h-4 text-gray-400 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    );
}


const ImageWithLoader = ({ src, alt, spinnerSize = 50 }) => {
    const [loading, setLoading] = useState(true);

    const handleImageLoad = () => {
        setLoading(false);
    };

    return (
        <div className="relative w-full h-full">
            {loading && (
                <div className="absolute inset-0 flex items-center justify-center bg-gray-100">
                    <Spinner className="h-8 w-8" />
                </div>
            )}
            <img
                src={src}
                alt={alt}
                onLoad={handleImageLoad}
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
            />
        </div>
    );
};
